import { createFileRoute, Link } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { useServerFn } from "@tanstack/react-start";
import { useAuth } from "@/hooks/use-auth";
import { adminListQuotes } from "@/lib/admin-dashboard.functions";

export const Route = createFileRoute("/_authenticated/admin/offertes")({
  head: () => ({ meta: [{ title: "Admin — Offertes" }, { name: "robots", content: "noindex" }] }),
  component: AdminQuotes,
});

function AdminQuotes() {
  const { isAdmin, loading } = useAuth();
  const list = useServerFn(adminListQuotes);

  const { data, isLoading } = useQuery({
    queryKey: ["admin-quotes"],
    queryFn: () => list({}),
    enabled: isAdmin,
  });

  if (loading) return <div className="p-8">Laden…</div>;
  if (!isAdmin) return <div className="p-8">Geen toegang.</div>;

  const quotes = data?.quotes ?? [];

  return (
    <div className="p-6 space-y-4 max-w-7xl mx-auto">
      <div>
        <h1 className="text-3xl font-bold">Offertes</h1>
        <p className="text-muted-foreground">{quotes.length} (laatste 200)</p>
      </div>

      <div className="border rounded-lg overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-muted">
            <tr>
              <th className="text-left p-2">Nummer</th>
              <th className="text-left p-2">Titel</th>
              <th className="text-left p-2">Datum</th>
              <th className="text-left p-2">Geldig tot</th>
              <th className="text-right p-2">Totaal</th>
              <th className="text-left p-2">Status</th>
              <th className="text-right p-2"></th>
            </tr>
          </thead>
          <tbody>
            {isLoading ? (
              <tr><td colSpan={7} className="p-4 text-center text-muted-foreground">Laden…</td></tr>
            ) : quotes.length === 0 ? (
              <tr><td colSpan={7} className="p-4 text-center text-muted-foreground">Geen offertes</td></tr>
            ) : quotes.map((q: any) => (
              <tr key={q.id} className="border-t">
                <td className="p-2 font-mono">{q.quote_number}</td>
                <td className="p-2">{q.title}</td>
                <td className="p-2">{new Date(q.created_at).toLocaleDateString("nl-NL")}</td>
                <td className="p-2">{q.valid_until ? new Date(q.valid_until).toLocaleDateString("nl-NL") : "—"}</td>
                <td className="p-2 text-right">€{(q.total_cents / 100).toFixed(2)}</td>
                <td className="p-2"><span className="inline-block px-2 py-0.5 rounded text-xs bg-muted">{q.status}</span></td>
                <td className="p-2 text-right">
                  <Link to="/account/offertes/$id" params={{ id: q.id }} className="text-primary text-sm hover:underline">Bekijk</Link>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
